import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

const TextFieldTime = (props) => {
  const { value } = props
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          {...props}
          // format="HH:mm"
          ampm={false}
          value={dayjs(value)}

        />
      </LocalizationProvider>
    </>

  );
};

export default TextFieldTime;
